var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "m9.616 18.626.06.034.023.013a.63.63 0 0 0 .602 0l.024-.013.059-.034q.076-.044.212-.128c.181-.11.436-.275.741-.49.609-.43 1.421-1.069 2.235-1.902 1.62-1.659 3.303-4.15 3.303-7.356a6.875 6.875 0 1 0-13.75 0c0 3.205 1.683 5.697 3.303 7.356a16.3 16.3 0 0 0 2.976 2.392q.136.084.212.128M10 11.25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",
    clipRule: "evenodd"
  })));
};
export default SvgMapPin;